import React from 'react';
import { Frown, Utensils, MicOff, Clock, AlertCircle, HeartCrack } from 'lucide-react';
export function PainMirrorSection() {
  const painPoints = [{
    icon: Utensils,
    text: 'Dentures moving when you chew or bite'
  }, {
    icon: MicOff,
    text: 'Fear of laughing too hard in public'
  }, {
    icon: Frown,
    text: 'Avoiding restaurants and social events'
  }, {
    icon: Clock,
    text: 'Adhesives that fail and dissolve by noon'
  }, {
    icon: AlertCircle,
    text: 'Constant anxiety every single day'
  }, {
    icon: HeartCrack,
    text: 'Embarrassment that steals your confidence'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-249">
      <div className="container mx-auto px-4 md:px-6" data-id="element-250">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-251">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-serif" data-id="element-252">
            Do You Recognize This?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-253">
            If you wear dentures, you likely know these struggles all too well.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-254">
          <div className="grid grid-cols-1 gap-4" data-id="element-255">
            {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 p-4 rounded-xl bg-rose-50 border border-rose-100 hover:border-rose-200 transition-colors" data-id="element-256">
                <div className="bg-white p-2 rounded-full shadow-sm shrink-0" data-id="element-257">
                  <point.icon className="w-6 h-6 text-red-600" data-id="element-258" />
                </div>
                <span className="text-lg font-medium text-gray-800" data-id="element-259">
                  {point.text}
                </span>
              </div>)}
            <div className="mt-6 text-center md:text-left" data-id="element-260">
              <p className="text-2xl font-bold text-gray-900 font-serif" data-id="element-261">
                "You don't have to live like this anymore."
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-262">
            <div className="grid grid-cols-2 gap-4" data-id="element-263">
              <img src="https://images.unsplash.com/photo-1559526324-593bc073d938?w=800&q=80" alt="Senior covering mouth" className="rounded-2xl shadow-lg w-full h-64 object-cover mt-8" data-id="element-264" />
              <img src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=800&q=80" alt="Dinner anxiety" className="rounded-2xl shadow-lg w-full h-64 object-cover" data-id="element-265" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-white/20 to-transparent pointer-events-none rounded-2xl" data-id="element-266" />
          </div>
        </div>
      </div>
    </section>;
}